import { render } from "./GoalList.vue?vue&type=template&id=97b49232&scoped=true"
import script from "./GoalList.vue?vue&type=script&lang=js"
export * from "./GoalList.vue?vue&type=script&lang=js"

import "./GoalList.vue?vue&type=style&index=0&id=97b49232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b49232"]])

export default __exports__